import CanvasJSReact from '@canvasjs/react-charts';
let CanvasJS = CanvasJSReact.CanvasJS;

const formatNumber = (number) => {
    let result = '00' + number.toString();
    return result.slice(result.length - 2);
}

export const numberWithSpaces = (x) => {
    let parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
}

export const timeConverter = (UNIX_timestamp) => {
    let a = new Date(UNIX_timestamp * 1000);
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let year = a.getFullYear();
    let month = months[a.getMonth()];
    let date = a.getDate();
    let hour = a.getHours();
    let min = a.getMinutes();
    let sec = a.getSeconds();
    let time = date + ' ' + month + ' ' + year + ' ' + formatNumber(hour) + ':' + formatNumber(min) + ':' + formatNumber(sec);
    return time;
}

export const getSummary = (description) => {
    let start_idx = description.indexOf('**Summary**');
    if (start_idx >= 0) {
        start_idx += 11;
        let end_idx = description.indexOf('**', start_idx);
        if (end_idx > 0) {
            return description.slice(start_idx, end_idx);
        } else
            return description.slice(start_idx, description.length);
    } else
        return "";
}

export const formatDate = (timestamp) =>{
    let curDate = new Date(timestamp * 1000);
    return formatNumber(curDate.getDate()) +"."+ formatNumber((curDate.getMonth()+1)) + "." + curDate.getFullYear()+ " " 
                + formatNumber(curDate.getHours())+':'+formatNumber(curDate.getMinutes());
}  

export const addSymbols = (e) => {
    let suffixes = ["", "K", "M", "B"];
    let order = Math.max(Math.floor(Math.log(Math.abs(e.value)) / Math.log(1000)), 0);
    if (order > suffixes.length - 1)
      order = suffixes.length - 1;
    let suffix = suffixes[order];
    return CanvasJS.formatNumber(e.value / Math.pow(1000, order)) + suffix;
  }